<div class="container">
  <h1 class="fs-2 fw-light mt-4">Property Notices</h1>

  <div class="form-group my-4">
    <label class="form-label" for="propertyname">Property Name</label>
    <input class="form-control col-3" type="text" [value]="propertyLabel" readonly />
  </div>

  <div class="form-group my-4">
    <label class="form-label" for="unitnumber">APT/LOT #</label>
    <input class="form-control col-3" type="text" [value]="unitLabel" readonly />
  </div>

  @if (loading) {
    <div class="alert alert-info">Loading notices...</div>
  }

  @if (!loading) {
    <div class="form-group my-3">
      <label class="form-label" for="noticeSearch">Quick Search</label>
      <input
        id="noticeSearch"
        type="text"
        class="form-control"
        placeholder="Search by description or unit"
        [(ngModel)]="searchQuery"
      />
    </div>

    <h2 class="fs-5 fw-light mt-4">Notices By Property</h2>
    <table class="table table-striped table-bordered">
      <thead class="py-1">
        <th scope="col">Short Description</th>
        <th scope="col">Long Description</th>
        <th scope="col">Visible Date</th>
      </thead>
      <tbody>
        @if (filteredPropertyNotices.length == 0) {
          <tr>
            <td colspan="3">No property notices match your search.</td>
          </tr>
        }

        @for (notice of filteredPropertyNotices; track notice.id) {
          <tr>
            <td>{{ notice.shortDescription }}</td>
            <td>{{ notice.longDescription }}</td>
            <td>{{ notice.dateVisible | date: 'MMM d, y' }}</td>
          </tr>
        }
      </tbody>
    </table>

    <h2 class="fs-5 fw-light mt-4">Notices By Premises</h2>
    <table class="table table-striped table-bordered">
      <thead class="py-1">
        <th scope="col">Unit</th>
        <th scope="col">Short Description</th>
        <th scope="col">Long Description</th>
        <th scope="col">Visible Date</th>
      </thead>
      <tbody>
        @if (filteredPremisesNotices.length == 0) {
          <tr>
            <td colspan="4">No premises notices match your search.</td>
          </tr>
        }

        @for (notice of filteredPremisesNotices; track notice.id) {
          <tr>
            <td>{{ notice.unit_number }}</td>
            <td>{{ notice.shortDescription }}</td>
            <td>{{ notice.longDescription }}</td>
            <td>{{ notice.dateVisible | date: 'MMM d, y' }}</td>
          </tr>
        }
      </tbody>
    </table>
  }

  <div class="mt-4">
    <button (click)="goBack()" class="btn btn-primary d-print-none"><fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back</button>
    <button (click)="goHome()" class="btn btn-info float-end d-print-none"><fa-icon [icon]="faHomeAlt"></fa-icon> Home</button>
  </div>
</div>
